import { action, get } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type Dialog from "cc-frontend/services/dialog"
import type EmberStore from "cc-frontend/services/ember-store"
import fade from "ember-animated/transitions/fade"

export default class DialogManager extends Component {
  fade = fade

  @service("ember-store") declare store: EmberStore

  @service declare dialog: Dialog

  @action
  accept() {
    get(this, "dialog").accept(...arguments)
  }

  @action
  decline() {
    get(this, "dialog").decline(...arguments)
  }

  @action onKeydown(event: KeyboardEvent) {
    switch (event.key) {
      // Ref: https://www.w3.org/TR/wai-aria-practices-1.2/#keyboard-interaction-12
      // `Escape` key is handled by focus-trap
      case "Enter":
        this.dialog.accept()
        break
    }
  }

  @action onExitKeydown(event: KeyboardEvent) {
    switch (event.key) {
      // Ref: https://www.w3.org/TR/wai-aria-practices-1.2/#keyboard-interaction-12
      case "Enter":
        this.dialog.decline()
        break
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    DialogManager: typeof DialogManager
  }
}
